import styled from "styled-components";

export const MainContainer = styled.div`
border: 1px solid green;
width: 15rem;
height: 9rem;
display: flex;
flex-direction: column;
justify-content:space-around;
align-items: center;
cursor: pointer;

:hover{
    background-color: #49bf59;
    color: white;
}

`